module.exports = __webpack_public_path__ + "static/img/809.05d500fb.png";